import { useContext } from 'react';

import StatsContext from './StatsContext';

const useStats = () => {
  const context = useContext(StatsContext);
  if (context === null) {
    throw new Error('useStats must be used within a StatsProvider');
  }
  return context;
};

export default useStats;
